import { useState } from 'react'
import { SidebarMobile } from '../../../sidebar/SidebarMobile'
import styles from './Hamburger.module.scss'

export const Hamburger = ({ links, logo, showCurrentTime = true }) => {
  const [sideNavbarOpen, setSideNavbarOpen] = useState(false)

  return (
    <>
      <button
        className={`${styles['hamburger__icon']} ${sideNavbarOpen ? styles['open'] : ''}`}
        onClick={() => setSideNavbarOpen(!sideNavbarOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div className={styles['hamburger__sidebar-container']}>
        <SidebarMobile
          links={links}
          logo={logo}
          sideNavbarOpen={sideNavbarOpen}
          setSideNavbarOpen={setSideNavbarOpen}
          showCurrentTime={showCurrentTime}
        />
      </div>
    </>
  )
}
